import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Calendar } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StartlistManager from "../components/StartlistManager";
import BulkPriceManager from "../components/BulkPriceManager";
import api from "../lib/api";

export default function EventManage() {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [photoCount, setPhotoCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const evs = await api.get("/events");
        const ev = evs.data.find((e) => e.id === id);
        if (!cancelled) setEvent(ev || null);
        const photos = await api.get(`/photos/search?event_id=${id}&limit=1`);
        if (!cancelled) {
          // Use count from /events directly
          setPhotoCount(ev?.photo_count ?? photos.data.length);
        }
      } catch {
        if (!cancelled) setEvent(null);
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  return (
    <div className="min-h-screen bg-bg flex flex-col">
      <Header />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8 flex-1 w-full">
        <Link
          to="/photographer/dashboard"
          className="text-sm text-white/60 hover:text-brand inline-flex items-center gap-1 mb-4"
          data-testid="event-manage-back"
        >
          <ArrowLeft className="w-4 h-4" /> Tillbaka till dashboard
        </Link>

        {event === null ? (
          <p className="text-white/40">Eventet hittades inte.</p>
        ) : (
          <>
            <div className="flex items-start justify-between gap-4 mb-6">
              <div>
                <p className="label-overline">Hantera event</p>
                <h1 className="font-display font-black uppercase text-white text-3xl">
                  {event?.name || "..."}
                </h1>
                <p className="text-white/50 text-sm mt-2 inline-flex items-center gap-2">
                  <Calendar className="w-4 h-4" />
                  {event?.date?.slice(0, 10)} · {event?.location || ""} · {photoCount ?? "..."} foton
                </p>
              </div>
              {event?.slug && (
                <Link
                  to={`/event/${event.slug}`}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-secondary text-xs py-2"
                  data-testid="event-manage-public-link"
                >
                  Visa publik sida →
                </Link>
              )}
            </div>

            {event && <StartlistManager eventId={event.id} />}

            {event && (
              <div className="mt-4">
                <BulkPriceManager eventId={event.id} photoCount={photoCount} />
              </div>
            )}

            <div className="card-surface p-5 mt-4">
              <p className="label-overline">Tips</p>
              <h3 className="font-display font-bold uppercase text-white text-lg mb-2">
                Så funkar startlistan
              </h3>
              <ul className="text-white/70 text-sm space-y-1.5 list-disc list-inside">
                <li>Ladda upp PDF:en med startlistan från tävlingen (oftast nedladdningsbar från arrangörens webb).</li>
                <li>AI:n tvingas att bara tagga nummer som finns i listan — fel-tolkningar (B vs 8, 13 vs 113) försvinner.</li>
                <li>Efter uppladdning kan du köra om OCR mot redan-uppladdade foton.</li>
                <li>Foton du redan har taggat manuellt ändras inte av re-OCR.</li>
                <li>Saknar du PDF? Klistra in startnummer direkt — kommaseparerad eller radvis.</li>
              </ul>
            </div>
          </>
        )}
      </div>
      <Footer />
    </div>
  );
}
